class Matomo
{
    /**
     * @param {videojs.Player} player
     */
    player;

    /**
     * @param {videojs.Player} player
     * @return {void}
     */
    setPlayer(player) {
        this.player = player;
    }

    /**
     * @return {string}
     */
    getTitle() {
        let src = this.player.currentSrc();
        let title = document.title;
        if (src) {
            const names = src.split('/');
            title = names[names.length - 1];
        }

        return title;
    }

    /**
     * @param {string} mode
     * @return {void}
     */
    sendMatomo(mode) {
        if (typeof _paq !== "undefined") {
            _paq.push(['trackEvent', 'Video', mode, this.getTitle()]);
        }
    }

    /**
     * @param {string} mode
     * @return {void}
     */
    sendErrorMatomo(mode) {
        if (typeof _paq !== "undefined") {
            const title = this.getTitle()
            _paq.push(['trackEvent', 'Video', mode, [title, JSON.stringify(this.player.error())].join(': ')]);
        }
    }
}

const matomo = new Matomo;
export { matomo as Matomo }
